module.exports = "/v2/pages/dashboard/dist/e7609d9fffccc9e031af728a6ea8ac67.svg";